// Content for the Communications page hero (audience map + multichannel orchestration).
export type Bi = { fr: string; en: string }

export const WATER_MAIN_PHOTO =
  'https://cdn.magicpatterns.com/patterns/generated-images/3b865d59-9b65-4d3c-a1a2-a18511c0b231.jpg'

export const heroCopy = {
  eyebrow: 'BCITI | ATNA — Communications',
  lines: {
    fr: ['Les bonnes personnes.', 'Le bon message.'],
    en: ['The right people.', 'The right message.'],
  },
  accent: { fr: 'Au bon moment.', en: 'At the right time.' },
  body: {
    fr: 'Du quotidien à l’urgence, joignez chaque public sur le bon canal — avec l’identité, le contexte et le suivi nécessaires pour vous assurer que le message a été reçu.',
    en: 'From everyday communications to critical situations, reach every audience through the right channel — with the identity, context and tracking to know the message got through.',
  },
  ctaPrimary: { fr: 'Voir en action', en: 'See it in action' },
  ctaSecondary: { fr: 'Communications d’urgence', en: 'Emergency communications' },
  values: { fr: 'Identité · Ciblage · Multicanal · Résultats', en: 'Identity · Targeting · Multichannel · Results' },
}

export const alertCard = {
  label: { fr: 'Alerte active', en: 'Active alert' },
  title: { fr: 'Bris d’aqueduc — Secteur B', en: 'Water main break — Sector B' },
  time: { fr: '12 mars, 10 h 24', en: 'March 12, 10:24 AM' },
  target: { fr: 'Secteur ciblé', en: 'Targeted sector' },
  targetSub: { fr: '1 842 citoyens concernés', en: '1,842 residents affected' },
  impact: {
    fr: 'Résidences, commerces et services municipaux touchés',
    en: 'Homes, businesses and municipal services affected',
  },
}

export const inputs = [
  { key: 'identity', title: { fr: 'Identité', en: 'Identity' }, sub: { fr: 'Citoyens, familles, propriétés, commerces', en: 'Residents, families, properties, businesses' } },
  { key: 'context', title: { fr: 'Contexte', en: 'Context' }, sub: { fr: 'Localisation, secteur, services, événements', en: 'Location, sector, services, events' } },
  { key: 'audience', title: { fr: 'Public cible', en: 'Audience' }, sub: { fr: 'Règles d’affaires, préférences, consentements', en: 'Business rules, preferences, consents' } },
  { key: 'data', title: { fr: 'Données', en: 'Data' }, sub: { fr: 'Systèmes municipaux et partenaires', en: 'Municipal and partner systems' } },
] as const

export const channels = [
  { key: 'push', label: { fr: 'Push', en: 'Push' } },
  { key: 'sms', label: { fr: 'SMS', en: 'SMS' } },
  { key: 'email', label: { fr: 'Courriel', en: 'Email' } },
  { key: 'voice', label: { fr: 'Voix', en: 'Voice' } },
  { key: 'web', label: { fr: 'Web / Appli', en: 'Web / App' } },
  { key: 'social', label: { fr: 'Réseaux sociaux', en: 'Social media' } },
] as const

export const targeted = {
  value: { fr: '1 842', en: '1,842' },
  label: { fr: 'personnes ciblées', en: 'people targeted' },
}

export const callout = {
  fr: ['Le bon message.', 'Sur le bon canal.', 'Au bon moment.'],
  en: ['The right message.', 'On the right channel.', 'At the right time.'],
}

export const phone = {
  date: { fr: 'Jeudi 12 mars', en: 'Thursday, March 12' },
  now: { fr: 'maintenant', en: 'now' },
  notifications: [
    {
      title: { fr: 'Avis important', en: 'Important notice' },
      body: { fr: 'Bris d’aqueduc dans votre secteur. Détails et consignes ›', en: 'Water main break in your area. Details and instructions ›' },
    },
    {
      title: { fr: 'Travaux en cours', en: 'Work in progress' },
      body: { fr: 'Les équipes sont sur place. Prochaine mise à jour à 15 h.', en: 'Crews are on site. Next update at 3 PM.' },
    },
  ],
}

export const resultsStrip = {
  reached: {
    value: { fr: '1 694', en: '1,694' },
    label: { fr: 'personnes jointes', en: 'people reached' },
    chip: { fr: '92 % de livraison', en: '92% delivered' },
  },
  rate: {
    value: { fr: '92 %', en: '92%' },
    label: { fr: 'taux de livraison', en: 'delivery rate' },
    chip: { fr: '+6 % par rapport à l’envoi précédent', en: '+6% vs previous send' },
  },
  missed: {
    value: { fr: '148', en: '148' },
    label: { fr: 'non joints', en: 'not reached' },
    chip: { fr: 'Relance automatique', en: 'Automatic follow-up' },
  },
  atna: {
    title: { fr: 'ATNA recommande', en: 'ATNA recommends' },
    body: { fr: 'Relance vocale à 18 h 30 pour les 148 non joints.', en: 'Voice follow-up at 6:30 PM for the 148 not reached.' },
    action: { fr: 'Planifier la relance', en: 'Schedule the follow-up' },
  },
}
